<template>
  <div class="cheyun_container">
    <div class="cheyun_header">
      <div class="cheyun_logo">
        <img src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/logo_20221226.png" />
      </div>
    </div>
    <div class="cheyun_wrapper">
      <div class="wrapper_tit">
        找回密码
      </div>
      <template v-if="step == 1">
        <div class="wrapper_text">
          请输入注册时的手机号码或邮箱名称，通过验证重新设置密码
        </div>
        <div class="wrapper_item">
          <div class="item_attr">邮箱：</div>
          <div class="item_val">
            <el-input
              v-model.trim="email"
              placeholder="请输入注册时的邮箱"
            />
          </div>
        </div>
        <div class="submit_btn" @click="nextStep">下一步</div>
      </template>
      <template v-if="step == 2">
        <div class="wrapper_text">
          密码找回的方式已发送到邮箱，<span class="text_email">{{email}}</span> 请登录邮箱查收！若长时间未收到邮件，<br>
          请再次发送，或者到垃圾邮箱查看。
        </div>
      </template>
     
    </div>
    <div class="cheyun_footer">
      <div class="footer_item">若果您在使用过程中，有任何问题，请拨打电话或者发送邮件：</div>
      <div class="footer_item"><span class="footer_text1">客服电话：</span><span class="footer_text2">133-8113-0566</span></div>
      <div class="footer_item">邮箱：help&#64;diandong.com</div>
      <div class="footer_item">网址：&nbsp;ceping.cheyun.com</div>
    </div>
  </div>
</template>

<script>
import {
  ref
} from "vue";
import {
  forgetPwd
} from "@/api";
import {
  ElInput,
  ElMessage
} from "element-plus"
export default {
  components:{
    ElInput
  },
  setup(){
    const email = ref("");
    const step = ref(1);
    let loading = false;
    const nextStep = ()=>{
      if(loading){
        return ;
      }
      if(!email.value){
        ElMessage.warning("请输入邮箱！");
        return;
      }
      loading = true;
      const myReg=/^[a-zA-Z0-9._+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
      if(!myReg.test(email.value)){
        ElMessage.warning("邮箱格式不正确！");
        return;
      }
      forgetPwd({email:email.value}).then(res=>{
        loading = false;
        if(res && res.code && res.code == 200){
          step.value=2;
        }
      })
    }
    return {
      email,
      step,
      nextStep
    }
  }
}
</script>

<style lang="less" scoped>
.cheyun_container{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 30px;
  width: 100%;
  height: 100%;
  .cheyun_header{
    width: 100%;
    height: 70px;
    border-bottom: solid 2px #18A8CA;
    display: flex;
    align-items: center;
    padding-left: 30px;
    flex-shrink: 0;
    .cheyun_logo{
      width: 278px;
      height: 29px;
      img{
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
  .cheyun_wrapper{
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .wrapper_tit{
      width: 1100px;
      font-size: 28px;
      color: #2c3638;
      height: 45px;
      margin-top: 60px;
      border-bottom: 1px #e6e6e6 solid;
      position: relative;
      &::after{
        content: "";
        width: 115px;
        height: 100%;
        border-bottom: 3px #1FBCBF solid;
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }
    .wrapper_text{
      font-size: 18px;
      text-align: center;
      line-height: 28px;
      margin: 60px 0;
      .text_email{
        display: inline;
        color: #1FBCBF;
      }
    }
    .wrapper_item{
      width: 540px;
      display: flex;
      align-items: center;
      &.wrapper_item2{
        margin-top: 22px;
      }
      &.wrapper_item3{
        margin-top: 18px;
      }
      .item_attr{
        font-size: 16px;
        font-weight: 400;
        color: #1F1F1F;
        width: 90px;
        padding-right: 10px;
        text-align: right;
      }
      .item_val{
        font-size: 14px;
        font-weight: 400;
        color: #7D7D7D;
        line-height: 20px;
        :deep(.el-input){
          width: 350px;
          height: 48px;
          background: #F4F4F4;
          border-radius: 6px;
        }
        :deep(.el-input .el-input__inner){
          width: 100%;
          height: 100%;
          padding-left: 33px;
          background: transparent;
          border: none;
        }
        :deep(.el-input .el-input__clear){
          height: 100%;
        }
      }
    }
    .submit_btn{
      margin-top: 50px;
      width: 170px;
      height: 47px;
      background: #1FBCBF;
      border-radius: 2px;
      font-size: 18px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 47px;
      text-align: center;
    }
  }
  .cheyun_footer{
    width: 100%;
    padding: 22px 0;
    background: #F4F4F4;
    flex-shrink: 0;
    .footer_item{
      font-size: 14px;
      font-weight: 400;
      color: #494949;
      text-align: center;
      line-height: 23px;
      .footer_text1{
        color: #000000;
        font-weight: 500;
      }
      .footer_text2{
        color: #318DE5;
      }
    }
  }
}
</style>